module.exports = __webpack_public_path__ + "img/ckgdicon.cffd76e2.svg";